import React from "react";
import { KeyboardArrowDown } from "@mui/icons-material"; // Import MUI arrow-down icon
import { useTranslation } from "react-i18next";
import { useLang } from "../../context/LangContext";
import hero1 from "../../images/ka3ba.jpg";
import icon from "../../images/favicon.png";

const Hero = () => {
  const { t } = useTranslation();
  const { lang } = useLang();

  const scrollToNextSection = () => {
    const nextSection = document.querySelector('.next-section');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="static-hero">
      <div className="container-fluid" dir="ltr">
        <div className="content">
          <div className="icon">
            <img src={icon} alt="icon" width={200} />
          </div>
          <h2
            className="title main-title"
            dir={lang === "ar" ? "rtl" : "ltr"}
          >
            {t(`quote`)}
          </h2>

          <div className="hero-btn">
            <button onClick={scrollToNextSection} className="theme-btn"
            >
              {t(`discoverMore`)}
              <KeyboardArrowDown
                sx={{ fontSize: "1.5rem", animation: "bounce 1.5s infinite" }}
              />
            </button>
          </div>
        </div>

        <div className="right-img">
          <img
            src={hero1}
            alt=""
            style={{
              width: "auto",
              maxWidth: "100%",
              objectFit: "cover",
              height: "100vh",
            }}
          />
        </div>
      </div>

      {/* Add keyframes for bounce animation */}
      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(5px); }
          }
        `}
      </style>
    </section>
  );
};

export default Hero;
